import script from "./Cancellation.vue?vue&type=script&setup=true&lang=ts"
export * from "./Cancellation.vue?vue&type=script&setup=true&lang=ts"

import "./Cancellation.vue?vue&type=style&index=0&id=ec7d7ed8&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec7d7ed8"]])

export default __exports__